import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconTitleButtonRound from "../buttons/IconTitleButtonRound";

import ICDoneIcon from '@material-ui/icons/Done';
import ICClearIcon from '@material-ui/icons/Clear';

export default function DialogMessage(props) {
    let messages
    if (props.message) {
        messages = props.message.split('\n').map((a, index) => {
            return <div key={index} style={{margin: "0.5em", textAlign: "right",minWidth:'10rem'}}>
                <label className="mediumTextBold">
                    {a}
                </label>
            </div>
        })
    }

    return (
        <Dialog open={props.showStatus} style={{textAlign: "right"}}>

            {props.title &&
            <DialogTitle>
                {props.title}
            </DialogTitle>
            }

            <DialogContent>
                {messages}
            </DialogContent>

            <div>
                <div className="horizontalScreen toLeft">
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            backgroundcolor={"var(--blue_3)"}
                            height={"2.5em"}
                            width={"100%"}
                            direction="ltr"
                            fontSize="mediumTextBold"
                            onClick={() => {
                                props.onSubmitClicked()
                            }}
                            icon={<ICDoneIcon
                                className={'whiteColor'}
                                fontSize={"small"}/>}
                            title={props.submitTitle ? props.submitTitle : messages.yes}/>
                    </div>
                    {props.closeTitle &&
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            backgroundcolor={"var(--red_3)"}
                            height={"2.5em"}
                            width={"100%"}
                            direction="ltr"
                            fontSize="mediumTextBold"
                            onClick={() => {
                                props.onCloseClicked()
                            }}
                            icon={<ICClearIcon
                                className={'whiteColor'}
                                fontSize={"small"}/>}
                            title={props.closeTitle ? props.closeTitle : messages.no}/>
                    </div>
                    }
                </div>
            </div>
        </Dialog>
    );
}